export default __webpack_public_path__ + "static/media/Diviner's Robe of Consumed Souls.eaff0808.jpg";